import { DemandsDateRangeChange } from '../../../Catalog/Interfaces/demands-filter-panel.interface';
import { ALL_DEMANDS_LIST_ROUTE } from '../../Demand/Consts/all-demands-display.const';
import { ReportSubjectTab } from '../../Demand/Types/report-subject-tab.type';
import { MonitoringValidatorRow } from '../Interfaces/monitoring-report.interface';
import { MonitoringRowLink } from '../Interfaces/monitoring-row-link.interface';

export function buildMonitoringDemandsLink(
  tab: ReportSubjectTab,
  subjectId: string,
  range: DemandsDateRangeChange,
): MonitoringRowLink {
  return {
    path: ALL_DEMANDS_LIST_ROUTE,
    queryParams: {
      subjectTab: tab,
      subjectId,
      requestedFrom: range.from,
      requestedTo: range.to,
    },
  };
}

export function buildMonitoringValidatorLink(
  validator: MonitoringValidatorRow,
  range: DemandsDateRangeChange,
): MonitoringRowLink {
  return {
    path: ALL_DEMANDS_LIST_ROUTE,
    queryParams: {
      subjectTab: validator.dominant_kind,
      decidedById: validator.id,
      requestedFrom: range.from,
      requestedTo: range.to,
    },
  };
}
